module.exports = __webpack_public_path__ + "static/media/about-bg.020c9eb8.jpg";